import type { InkTrendPoint } from "./types";

/**
 * Deterministic mock dataset (no CubeJS backend for this widget): the last 14
 * days of Jobcount and Printed Length, stable across reloads. Swapping in the
 * real API is a body-only change in `thunks.ts`.
 */

const DAYS = 14;
const BASE_JOBS = 120;
const BASE_LENGTH = 8400; // meters per day

export function generateInkTrend(): InkTrendPoint[] {
  const today = new Date();
  return Array.from({ length: DAYS }, (_, index) => {
    const day = new Date(today);
    day.setDate(day.getDate() - (DAYS - 1 - index));
    // Weekly rhythm: quieter weekends, plus a small deterministic jitter.
    const dayOfWeek = day.getDay();
    const weekendFactor = dayOfWeek === 0 || dayOfWeek === 6 ? 0.45 : 1;
    const jitter = ((index * 97) % 60) - 30;

    return {
      date: day.toISOString().slice(0, 10),
      Jobcount: Math.max(
        0,
        Math.round(BASE_JOBS * weekendFactor + jitter + index * 2),
      ),
      "Printed Length": Math.max(
        0,
        Math.round(BASE_LENGTH * weekendFactor + jitter * 90 + index * 130),
      ),
    };
  });
}
